import { useEffect } from 'react';
import { connect } from 'react-redux';
import IwModals from '../iwModals/IwModals';
import MainContent from './pageStructure/mainContent/MainContent';
import { ACTIVATE_MY_ACCOUNT } from './MyAccount.actions';
import styles from './MyAccount.module.css';
import Navigation from './navigation/Navigation';
import { Dispatch } from 'redux';
import { ACTIVATE_NAVIGATION } from './navigation/Navigation.actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    activateMyAccount: () => dispatch({ type: ACTIVATE_MY_ACCOUNT }),
    activateNavigation: () => dispatch({ type: ACTIVATE_NAVIGATION })
});

const MyAccount = ({
    activateMyAccount,
    activateNavigation
}: ReturnType<typeof mapDispatchToProps>) => {
    useEffect(() => {
        activateMyAccount();
    }, [activateMyAccount]);

    useEffect(() => {
        activateNavigation();
    }, [activateNavigation]);

    return (
        <div className={styles.MyAccount}>
            <Navigation />
            <div className={styles.contentContainer}>
                {/* @ts-expect-error */}
                <MainContent />
            </div>
            <IwModals />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(MyAccount);
